import { TurnosService } from './src/services/turnos.services';

export type { Categoria, AcreditadoTurno, TurnoDisponible, FranjaDisponible } from './src/services/suite.interfaces';

export const turnosService = new TurnosService();

export default turnosService;
